export default {
    theme: {
        fontFamily: {
            sans: ['proximanova', 'sans-serif'],
        },
        screens: {
            xs: '400px',
            sm: '576px',
            md: '768px',
            lg: '1024px',
            xl: '1300px',
            '2xl': '1300px',
        },
        extend: {
            colors: {
                primary: {
                    DEFAULT: '#055988',
                },
                secondary: {
                    DEFAULT: '#f6ab2f',
                },
                tertiary: {
                    DEFAULT: '#34b4f5',
                    50: '#293f4d',
                },
                light: '#f8f9fa',
                body: { DEFAULT: '#666' },
                gray: {
                    DEFAULT: '#efefef',
                    50: '#f8f9fa',
                    500: '#a0a6b1',
                    800: '#343a40',
                },
                stars: {
                    900: '#EDBD40',
                    0: '#AEBFD1',
                },
                error: {
                    DEFAULT: '#FF3738',
                },
                btn: {
                    DEFAULT: '#e62571',
                    border: '#e93f82',
                    hover: '#cd185f',
                    borderHover: '#b41658',
                    secondary: '#055988',
                    secondaryHover: '#084b72',
                },
                brand: {
                    muted: '#d1e3ec',
                    'muted-light': '#ebf2f6',
                    'dark-gray': '#111827',
                },
            },
        },
    },
};
